module.exports = __webpack_public_path__ + "static/media/cleanvertising-light.34d355d5.woff2";